<template>
  <div
    class="lack-of-rest-alert-tooltip-text z-10 aisea-text-14-400-white pl-1"
  >
    <div class="alert-title">過去48時間以内に以下のアラートが発生している人数を表示しています。</div>
    <div class="alert-item">・1日間のうち最長の休息時間が6時間未満</div>
  </div>
</template>
<script>
export default {
  name: "TooltipTextLackOfRest",
  components: {},
};
</script>
<style lang="scss">
.lack-of-rest-alert-tooltip-text {
  .alert-title {
    margin-bottom: 10px;
  }
  .alert-item {
    font-weight: 600;
  }
}
</style>
